import { render, staticRenderFns } from "./repairOrderListOld.vue?vue&type=template&id=0bf85987&scoped=true&"
import script from "./repairOrderListOld.vue?vue&type=script&lang=js&"
export * from "./repairOrderListOld.vue?vue&type=script&lang=js&"
import style0 from "./repairOrderListOld.vue?vue&type=style&index=0&id=0bf85987&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf85987",
  null
  
)

export default component.exports